module.exports = __webpack_public_path__ + "img/IMG_1039_L_WoodMatted_MockedUp.6bc69abb.jpg";